import CustomerSubscriptionDetail from "../CustomerSubscriptionDetail";
import styles from "./CustomerSubscriptionDetailWrapper.module.scss";
import Space from "../../components/Space";
export default function CustomerSubscriptionDetailWrapper({ match, location }) {
  return (
    <div style={{ padding: "48px" }}>
      <Space size="xxl">
        <div className={styles.space}>
          <CustomerSubscriptionDetail match={match} location={location} />
        </div>
      </Space>
    </div>
  );
}
